import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArcButton } from "@/components/ArcButton";
import { Lock } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const user = await login(email, password);
      navigate(user.role === "admin" ? "/admin" : "/");
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="mx-auto flex max-w-md flex-col px-4 py-20 sm:px-6">
      <div className="mb-6 flex h-12 w-12 items-center justify-center self-start rounded-md" style={{ backgroundColor: "var(--ghoulax-soft)" }}>
        <Lock size={22} style={{ color: "var(--ghoulax)" }} />
      </div>
      <h1 className="font-serif-arc text-3xl font-black tracking-tight">Archive Sign In</h1>
      <p className="mt-2 text-sm" style={{ color: "var(--arc-text-2)" }}>Administrators and editors only.</p>

      <form onSubmit={submit} className="mt-8 space-y-5 rounded-md border p-6 shadow-sm" style={{ backgroundColor: "var(--arc-card)" }}>
        {error && <div data-testid="login-error" className="rounded border border-red-300 bg-red-50 px-3 py-2 text-sm text-red-700 dark:bg-red-900/30 dark:text-red-300">{error}</div>}
        <div className="space-y-2">
          <Label>Email</Label>
          <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" required />
        </div>
        <div className="space-y-2">
          <Label>Password</Label>
          <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
        </div>
        <ArcButton variant="ghoulax" type="submit" disabled={loading} data-testid="login-submit" className="w-full">
          {loading ? "Signing in…" : "Sign In"}
        </ArcButton>
      </form>
    </div>
  );
}
